<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.paragraph.title') }}</h2>
            <div class="card-toolbar">
                <el-switch
                    v-model="paragraphPreview"
                    size="large"
                    :active-text="$t('pages.module.eTep.question.save.questionType.paragraph.paragraphCode')"
                    :inactive-text="$t('pages.module.eTep.question.save.questionType.paragraph.paragraphPreview')"
                />
            </div>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="row" v-if="data.paragraphs.length">

                <div v-if="!paragraphPreview" class="col-md-12">
                    <div v-for="(paragraph, paragraphIndex) in data.paragraphs" :key="paragraph.hash">
                        <span class="text-gray-800 fs-4 fw-bolder">
                            {{ sprintf($t('pages.module.eTep.question.save.questionType.paragraph.titlePattern'), [$root.questionLetters[paragraphIndex]]) }}
                        </span>
                        <div v-html="paragraph.content"></div>
                    </div>
                </div>

                <div v-else class="col-md-12" v-for="(paragraph, paragraphIndex) in data.paragraphs" :key="paragraph.hash" :class="[(paragraphIndex > 0 ? 'mt-md-20' : 'mt-md-0'), paragraphIndex !== 0 && 'mt-20' ]">
                    <div class="mb-2 d-flex justify-content-between align-items-center">
                        <div class="text-gray-800 fs-4 fw-bolder">
                            {{ sprintf($t('pages.module.eTep.question.save.questionType.paragraph.titlePattern'), [$root.questionLetters[paragraphIndex]]) }}
                        </div>
                        <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteParagraph(paragraphIndex, paragraphIndex)">
                            <template #reference>
                                <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> Kaldır</button>
                            </template>
                        </el-popconfirm>
                    </div>
                    <div class="border border-gray-300 pt-5 px-3 pb-0 rounded">
                        <div class="fv-row mb-1">
                            <el-form-item :prop="'data.data.paragraphs[' + paragraphIndex + '].content'" :rules="$validation.getMessage(['required'])">
                                <CustomCkeditor :model="paragraph.content" @updateModel="paragraph.content = $event"></CustomCkeditor>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex flex-column align-items-center justify-content-center py-5">
                <p class="text-gray-600 text-center">{{ $t('pages.module.eTep.question.save.questionType.paragraph.paragraphAddContent') }}</p>
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <button class="btn btn-flex btn-primary" v-on:click="addParagraph" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                        </span>
                        {{ $t('pages.module.eTep.question.save.questionType.paragraph.paragraphAdd') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="card-footer" v-if="data.paragraphs.length">
            <button class="btn btn-flex btn-primary" v-on:click="addParagraph" type="button">
                    <span class="svg-icon svg-icon-2">
                        <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                    </span>
                {{ $t('pages.module.eTep.question.save.questionType.paragraph.paragraphAdd') }}
            </button>
        </div>
    </div>
    <div class="card mt-7" v-if="updateStatus">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.subQuestionType.title') }}</h2>
        </div>
        <div class="card-body">
            <div class="row" v-if="subQuestions?.length">
                <div v-for="(subQuestion, subQuestionIndex) in subQuestions" :key="subQuestionIndex">

                    <div v-if="subQuestion.sub_question_type_id === 1" :class="[(subQuestionIndex > 0 ? 'mt-md-20' : 'mt-md-0'), subQuestionIndex !== 0 && 'mt-20' ]">
                        <div class="mb-2 d-flex justify-content-between align-items-center">
                            <div class="text-gray-800 fs-4 fw-bolder">
                                {{ sprintf($t('pages.module.eTep.question.save.subQuestionType.paragraphReference.titlePattern'), [(subQuestionIndex + 1)]) }} (Paragraph Reference)
                            </div>
                            <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteSubQuestion(subQuestion, subQuestionIndex)">
                                <template #reference>
                                    <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> Kaldır</button>
                                </template>
                            </el-popconfirm>
                        </div>
                        <div class="border border-gray-300 pt-5 px-3 pb-0 rounded">
                            <div class="fv-row mb-1">
                                <el-form-item :prop="'data.sub_questions[' + subQuestionIndex + '].data.title'" :rules="$validation.getMessage(['required'])">
                                    <CustomCkeditor :model="subQuestion.data.title" @updateModel="subQuestion.data.title = $event" ></CustomCkeditor>
                                </el-form-item>
                                <div class="d-flex align-items-md-center justify-content-md-between flex-md-row flex-column">
                                    <el-tooltip
                                        class="box-item"
                                        effect="light"
                                        :content="$t('pages.module.eTep.question.save.subQuestionType.paragraphReference.trueParagraph')"
                                        placement="top-start"
                                    >
                                        <el-form-item :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="subQuestion.correct_answer" :disabled="!subQuestion.id">
                                                <el-option
                                                    v-for="(paragraph, paragraphIndex) in data.paragraphs"
                                                    :key="paragraph.hash"
                                                    :value="paragraph.hash"
                                                    :label="sprintf($t('pages.module.eTep.question.save.questionType.paragraph.titlePattern'), [$root.questionLetters[paragraphIndex]])"
                                                >
                                                    {{ sprintf($t('pages.module.eTep.question.save.questionType.paragraph.titlePattern'), [$root.questionLetters[paragraphIndex]]) }}
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-tooltip>
                                    <el-form-item :rules="$validation.getMessage(['required'])">
                                        <el-input-number v-model="subQuestion.sort" :min="1"/>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="subQuestion.sub_question_type_id === 2" :class="[(subQuestionIndex > 0 ? 'mt-md-20' : 'mt-md-0'), subQuestionIndex !== 0 && 'mt-20' ]">
                        <div class="mb-2 d-flex justify-content-between align-items-center">
                            <div class="text-gray-800 fs-4 fw-bolder">
                                {{ sprintf($t('pages.module.eTep.question.save.subQuestionType.paragraphReference.titlePattern'), [(subQuestionIndex + 1)]) }} (Paragraph Multi Choice)
                            </div>
                            <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteSubQuestion(subQuestion, subQuestionIndex)">
                                <template #reference>
                                    <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> Kaldır</button>
                                </template>
                            </el-popconfirm>
                        </div>
                        <div class="border border-gray-300 pt-5 px-3 pb-0 rounded">
                            <div class="fv-row mb-1">
                                <el-form-item :prop="'data.sub_questions[' + subQuestionIndex + '].data.title'" :rules="$validation.getMessage(['required'])">
                                    <CustomCkeditor :model="subQuestion.data.title" @updateModel="subQuestion.data.title = $event"></CustomCkeditor>
                                </el-form-item>

                                <div class="border border-gray-300 pt-5 px-3 pb-0 rounded bg-light-dark">

                                    <div class="mb-4 d-flex justify-content-between align-items-center">
                                        <div class="text-gray-800 fs-4 fw-bolder">
                                            {{ sprintf($t('pages.module.eTep.question.save.answer.title')) }}
                                        </div>
                                        <div class="card-toolbar">
                                            <button class="btn btn-flex btn-primary" v-on:click="addAnswer(subQuestionIndex)" type="button" :disabled="!subQuestion.id">
                                                    <span class="svg-icon svg-icon-2">
                                                        <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                                                    </span>
                                                {{ $t('pages.module.eTep.question.save.answer.add') }}
                                            </button>
                                        </div>
                                    </div>

                                    <div v-for="(answer, answerIndex) in subQuestion.answers" :key="answerIndex">
                                        <div class="mb-2 d-flex justify-content-between align-items-center" :class="[(answerIndex > 0) , 'border-top border-gray-300 pt-3']">
                                            <div class="text-gray-800 fs-4 fw-bolder">
                                                {{ sprintf($t('pages.module.eTep.question.save.answer.titlePattern'), [$root.questionLetters[answerIndex]]) }}
                                            </div>
                                            <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteAnswer(subQuestionIndex, answer, answerIndex)">
                                                <template #reference>
                                                    <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> Kaldır</button>
                                                </template>
                                            </el-popconfirm>
                                        </div>
                                        <el-form-item :prop="'data.sub_questions[' + subQuestionIndex + '].answers[' + answerIndex + '].data.content'" :rules="$validation.getMessage(['required'])">
                                            <CustomCkeditor :model="answer.data.content" @updateModel="answer.data.content = $event"></CustomCkeditor>
                                        </el-form-item>
                                        <el-form-item :rules="$validation.getMessage(['required'])">
                                            <el-input-number v-model="answer.sort" :min="1"/>
                                        </el-form-item>
                                    </div>
                                </div>

                                <div class="d-flex align-items-md-center justify-content-md-between flex-md-row flex-column mt-4">
                                    <el-tooltip
                                        class="box-item"
                                        effect="light"
                                        :content="$t('pages.module.eTep.question.save.answer.selectAnswer')"
                                        placement="top-start"
                                    >
                                        <el-form-item :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="subQuestion.correct_answer" :disabled="!subQuestion.id || !subQuestion.answers?.length" :placeholder="$t('pages.module.eTep.question.save.answer.selectAnswer')">
                                                <el-option
                                                    v-for="(answer, answerIndex) in subQuestion.answers.filter(a => a.id)"
                                                    :key="answerIndex"
                                                    :value="String(answer.id)"
                                                    :label="sprintf($t('pages.module.eTep.question.save.answer.titlePattern'), [$root.questionLetters[answerIndex]])"
                                                >
                                                    {{ sprintf($t('pages.module.eTep.question.save.answer.titlePattern'), [$root.questionLetters[answerIndex]]) }}
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-tooltip>
                                    <el-form-item :rules="$validation.getMessage(['required'])">
                                        <el-input-number v-model="subQuestion.sort" :min="1"/>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div v-else class="d-flex flex-column align-items-center justify-content-center py-5">
                <p class="text-gray-600 text-center">{{ $t('pages.module.eTep.question.save.subQuestionType.subQuestionAddContent') }}</p>
                <div class="d-flex flex-column flex-md-row align-items-center justify-content-center">
                    <button class="btn btn-flex btn-primary me-2" v-for="(type, typeIndex) in subQuestionTypes" :key="typeIndex" v-on:click="addSubQuestion(type.id)" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                        </span>
                        {{ $t('pages.module.eTep.question.save.subQuestionType.code.' + type.code) }}
                    </button>
                </div>
            </div>
        </div>
        <div class="card-footer" v-if="subQuestions?.length">
            <button class="btn btn-flex btn-primary me-2" v-for="(type, typeIndex) in subQuestionTypes" :key="typeIndex" v-on:click="addSubQuestion(type.id)" type="button">
                <span class="svg-icon svg-icon-2">
                    <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                </span>
                {{ $t('pages.module.eTep.question.save.subQuestionType.code.' + type.code) }}
            </button>
        </div>
    </div>
</template>

<script>
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";
import md5 from 'md5'

export default {
    name: "Paragraph",
    props: {
        data: Object,
        subQuestionTypes: Array,
        subQuestions: Array,
        updateStatus: Boolean
    },
    data() {
        return {
            paragraphPreview: true,
        }
    },
    components: {
        CustomCkeditor
    },
    methods: {
        deleteParagraph(paragraph, paragraphIndex) {
            this.data.paragraphs.splice(paragraphIndex, 1);
        },
        addParagraph() {
            this.data.paragraphs.push({
                "hash": this.generateHash(),
                "content": ""
            })
        },
        generateHash() {
            const timestamp = Date.now().toString()
            const random = Math.random().toString(36).substring(2, 10)
            const input = `${timestamp}-${random}`
            this.paragraphPreview = true
            return md5(input);
        },
        addSubQuestion(typeId) {
            let subQuestionLength = this.subQuestions.length;
            this.subQuestions.push({
                id: false,
                sub_question_type_id: typeId,
                data: {
                    title: '',
                },
                answers: [],
                sort: this.subQuestions.length !== 0 ? (this.subQuestions[subQuestionLength - 1].sort + 1) : 1,
            })
        },
        deleteSubQuestion(value, index) {
            if (value.id) {
                this.$store.dispatch("module/etep/question/sub/delete", {
                    id: [value.id]
                }).then((successDeleted) => {
                    if (successDeleted) {
                        this.$emit('load-question', true)
                    }
                });
            } else {
                this.subQuestions.splice(index, 1);
            }
        },
        addAnswer(index) {
            let subQuestionLength = this.subQuestions[index].answers.length;
            this.subQuestions[index].answers.push({
                data: {
                    content: ''
                },
                sort: subQuestionLength !== 0 ? (this.subQuestions[index].answers[subQuestionLength - 1].sort + 1) : 1,
            })
        },
        deleteAnswer(indexSubQuest, value, index) {
            if (value.id) {
                this.$store.dispatch("module/etep/question/answer/delete", {
                    id: [value.id]
                }).then((successDeleted) => {
                    if (successDeleted) {
                        this.$emit('load-question', true)
                    }
                });
            } else {
                this.subQuestions[indexSubQuest].answers.splice(index, 1);
            }
        }
    }
};
</script>
